<ion-card>
  <ion-card-header>
    <ion-card-title>Iktatókönyvek</ion-card-title>
    <ion-card-subtitle>
      Egy intézményben több könyv is nyitható – például külön tanügyi és gazdasági.
      A könyv <b>jele</b> az iktatószám része (T/12-3/2026), így a számok nem keverednek.
      Zárt könyvbe nem lehet iktatni; a zárás után a könyv hitelesíthető.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-button size="small" (click)="ujForm = !ujForm">
        <ion-icon slot="start" name="add-outline"></ion-icon>Új iktatókönyv
      </ion-button>
    </div>

    <div class="ikt-fejsor" *ngIf="ujForm">
      <ion-input label="Név" label-placement="stacked" [(ngModel)]="uj.nev"
                 placeholder="pl. Tanügyi iktatókönyv"></ion-input>
      <ion-input label="Jel" label-placement="stacked" [(ngModel)]="uj.jel"
                 placeholder="pl. T"></ion-input>
      <ion-input label="Év" label-placement="stacked" type="number" [(ngModel)]="uj.ev"></ion-input>
      <ion-input label="Leírás" label-placement="stacked" [(ngModel)]="uj.leiras"></ion-input>
      <ion-button size="small" (click)="letrehoz()">Megnyitás</ion-button>
    </div>

    <div class="ikt-tabla-doboz">
      <table class="ikt-tabla">
        <thead>
          <tr>
            <th>Név</th><th>Jel</th><th class="szam">Év</th><th class="szam">Ügyiratok</th>
            <th class="szam">Utolsó főszám</th><th>Állapot</th><th>Hitelesítés</th><th>Művelet</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let k of konyvek">
            <td>{{ k.nev }}</td>
            <td class="iktszam">{{ k.jel }}</td>
            <td class="szam">{{ k.ev }}</td>
            <td class="szam">{{ k.ugyirat_db }}</td>
            <td class="szam">{{ k.utolso_fosorszam }}</td>
            <td><ion-badge [color]="k.allapot === 'nyitva' ? 'success' : 'medium'">{{ k.allapot }}</ion-badge></td>
            <td>
              <span *ngIf="k.hitelesitve_ekkor">{{ k.hitelesitve_ekkor | date: 'yyyy. MM. dd.' }}</span>
              <span *ngIf="!k.hitelesitve_ekkor" style="color:var(--ion-color-medium)">—</span>
            </td>
            <td>
              <ion-button size="small" fill="clear" *ngIf="!(+k.ugyirat_db)"
                          (click)="jelJavitas(k)">Jel javítása</ion-button>
              <ion-button size="small" fill="clear" *ngIf="k.allapot === 'nyitva'"
                          (click)="muvelet(k, 'zaras', 'Lezárod a(z) ' + k.nev + ' könyvet? Utána nem lehet bele iktatni.')">
                Zárás
              </ion-button>
              <ion-button size="small" fill="clear" *ngIf="k.allapot !== 'nyitva'"
                          (click)="muvelet(k, 'ujranyitas', 'Újranyitod a könyvet?')">Újranyitás</ion-button>
              <ion-button size="small" fill="clear" *ngIf="k.allapot !== 'nyitva' && !k.hitelesitve_ekkor"
                          (click)="muvelet(k, 'hitelesites', 'Hitelesíted a lezárt könyvet?')">Hitelesítés</ion-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ikt-ures" *ngIf="!konyvek.length">
        Még nincs iktatókönyv. Nyiss egyet – enélkül nem lehet iktatni.
      </div>
    </div>
  </ion-card-content>
</ion-card>
